var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f2f2f2"}},[_c('common-head',{attrs:{"active":"0","state":"1"}}),_c('index-activity'),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }